import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M22.7,4H2.3C1,4,0,5.1,0,6.5V19c0,1.4,1,2.5,2.3,2.5h20.5c1.3,0,2.3-1.1,2.3-2.5V6.5C25,5.1,24,4,22.7,4z M22.7,5c0.1,0,0.3,0,0.4,0.1l-10.6,9.3L1.9,5.1C2,5,2.1,5,2.3,5H22.7z M2.3,20.5c-0.1,0-0.3,0-0.4-0.1l7.3-6.3l-0.7-0.6l-7.3,6.4 C1,19.6,0.9,19.3,0.9,19V6.5c0-0.3,0.1-0.6,0.2-0.8l11.4,9.9l11.4-9.9c0.1,0.2,0.2,0.5,0.2,0.8V19c0,0.3-0.1,0.6-0.2,0.8l-7.3-6.4 l-0.7,0.6l7.3,6.4c-0.1,0-0.3,0.1-0.4,0.1H2.3z" />
    </g>
  </svg>
);
